/* tslint:disable */
import { ViewStran } from './view-stran';

/**
 */
export class ViewAdminTran {
    admintrans?: ViewStran[];
    idlang?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-admin-tran.ts